import { render, staticRenderFns } from "./PaymentPlanCompanyNotification.vue?vue&type=template&id=6386334a&"
import script from "./PaymentPlanCompanyNotification.vue?vue&type=script&lang=js&"
export * from "./PaymentPlanCompanyNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports